import React from "react";
import { Toolbar, SaveButton } from "react-admin";

export const ToolbarSave = (props) => {
  return (
    <Toolbar {...props} >
      <SaveButton />
    </Toolbar>
  );
}



// WEBPACK FOOTER //
// ./src/components/toolbarSave.js